import axios from 'axios';
import { API_URL } from 'utils';

/**
 * @return {Promise<import('./login').TLogin>}
 */
export default async function refreshToken() {
  return axios(`${API_URL}/auth/refresh`, {
    withCredentials: true,
  });
};

